// src/data/courseContent.js
export const courseContent = {
    title: 'Data Structures & Algorithms Course',
    enrolled: 3000,
    enrolledGrowth: '+0%',
    completed: 2100,
    completionRate: '70%',
    steps: 40,
    stepDescription: 'Lessons, quizzes, and projects',
    rating: 4.92,
    reviewsCount: 43,
    slug: 'DSA',
    price: 'KES 5,000',
    instructors: 'John Doe, Jane Doe',
    category: 'General Programming',
    level: 'Advanced',
    lastUpdated: '2 days ago',
    lastUpdatedBy: 'John Doe',
    description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
    summary: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.',
    pathways: ['Software Engineering', 'Data Science'],
    reviews: [
        {
            id: 1, 
            author: 'Anonymous', 
            rating: 4, 
            text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.', 
            date: '2 days ago',
            avatar: '/api/placeholder/40/40'
        },
        {
            id: 2, 
            author: 'John Doe', 
            rating: 5, 
            text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.', 
            date: '3 days ago',
            avatar: '/api/placeholder/40/40'
        },
        {
            id: 3, 
            author: 'John Doe', 
            rating: 5, 
            text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.', 
            date: '3 days ago',
            avatar: '/api/placeholder/40/40'
        },
        {
            id: 4, 
            author: 'John Doe', 
            rating: 5, 
            text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.', 
            date: '3 days ago',
            avatar: '/api/placeholder/40/40'
        },
        {
            id: 5, 
            author: 'John Doe', 
            rating: 5, 
            text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.', 
            date: '3 days ago',
            avatar: '/api/placeholder/40/40'
        },
    ],
    topics: [
        {
      id: 1,
      title: "1.1 Introduction to React.JS",
      description: "Topic description comes here",
      lessons: [
        { id: 1, title: "What is React?", type: "Text, Video" },
        { id: 2, title: "Setting-up development environment", type: "Text, Video" },
        { id: 3, title: "Your first React App", type: "Text, Video" }
      ],
      quizzes: [
        { id: 1, title: "React Basics Quiz", points: 10 }
      ],
      projects: [
        { id: 1, title: "Build React Component Challenge", points: 25 }
      ]
    },
    {
      id: 2,
      title: "1.2 Introduction to React.JS",
      description: "Topic description comes here",
      lessons: [
        { id: 1, title: "What is React?", type: "Text, Video" },
        { id: 2, title: "Setting-up development environment", type: "Text, Video" }
      ],
      quizzes: [],
      projects: [
        { id: 1, title: "Build React Component Challenge", points: 25 }
      ]
    },
    {
      id: 3,
      title: "1.3 Introduction to React.JS",
      description: "Topic description comes here",
      lessons: [
        { id: 1, title: "What is React?", type: "Text, Video" },
        { id: 2, title: "Setting-up development environment", type: "Text, Video" },
        { id: 3, title: "Your first React App", type: "Text, Video" }
      ],
      quizzes: [],
      projects: []
    },
    {
      id: 4,
      title: "1.4 Introduction to React.JS",
      description: "Topic description comes here",
      lessons: [],
      quizzes: [],
      projects: [
        { id: 1, title: "Build React Component Challenge", points: 25 }
      ]
    }
    ]
}

